import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { formatDistance, addDays, format } from 'date-fns'
import sv from 'date-fns/locale/sv'

export const deliveryAddressValidations = {
  address_line1: {
    required
  },
  zip_code: {
    required,
    minLength: minLength(5),
    maxLength: maxLength(6)
  },
  city: {
    required
  }
}

export const licenseValidations = {
  email: {
    required,
    email
  }
}

export const expiresSoon = (subscription) => {
  // Soon is within 100 days
  if (subscription.active) {
    const expiresDate = subscription.expires ? new Date(subscription.expires) : false
    const nowDate = new Date()
    if (expiresDate && expiresDate > nowDate && expiresDate < addDays(nowDate, 100)) {
      return true
    }
  }
  return false
}

export const status = (subscription) => {
  if (subscription.active) {
    if (subscription.expires) {
      return formatDistance(new Date(subscription.expires), new Date(), { locale: sv }) + ' kvar'
    }
    return 'Aktiv'
  }
  return 'Inaktiv'
}

export const statusClasses = (subscription) => {
  return {
    Status: true,
    'Status--inactive': !subscription.active,
    'Status--expires': expiresSoon(subscription)
  }
}

export const duration = (subscription) => {
  if (subscription.active) {
    return format(new Date(subscription.created), 'yyyy-MM-dd') + ' – ' + format(new Date(subscription.expires), 'yyyy-MM-dd')
  }
  return '-'
}

export const invoiceDueDate = (invoice) => {
  return format(addDays(new Date(invoice.created), invoice.payment_terms), 'yyyy-MM-dd')
}

export const invoiceDate = (invoice) => {
  return format(new Date(invoice.created), 'yyyy-MM-dd')
}
